import api from './index';
import type {
  Document,
  CreateDocumentRequest,
  CreateDocumentFromS3Request,
  GenerateUploadUrlRequest,
  UploadUrlResponse,
  SyncDocumentRequest,
  DocumentsResponse
} from './types/document';

class DocumentsApi {
  async getDocumentsBySessionId(
    sessionId: string,
    page = 1,
    limit = 50
  ): Promise<DocumentsResponse> {
    const response = await api.get(`/documents/session/${sessionId}`, {
      params: { page, limit }
    });
    return response.data;
  }

  async getDocumentsByCampaignId(
    campaignId: string,
    page = 1,
    limit = 50
  ): Promise<DocumentsResponse> {
    const response = await api.get(`/documents/campaign/${campaignId}`, {
      params: { page, limit }
    });
    return response.data;
  }

  async createDocument(data: CreateDocumentRequest): Promise<Document> {
    const response = await api.post('/documents', data);
    return response.data;
  }

  async createDocumentFromS3(data: CreateDocumentFromS3Request): Promise<Document> {
    const response = await api.post('/documents/from-s3', data);
    return response.data;
  }

  async generateUploadUrl(data: GenerateUploadUrlRequest): Promise<UploadUrlResponse> {
    const response = await api.post('/documents/upload-url', data);
    return response.data;
  }

  async syncDocument(data: SyncDocumentRequest): Promise<Document> {
    const response = await api.post(`/documents/${data.documentId}/sync`);
    return response.data;
  }

  async deleteDocument(documentId: string): Promise<void> {
    await api.delete(`/documents/${documentId}`);
  }

  async getDocument(documentId: string): Promise<Document> {
    const response = await api.get(`/documents/${documentId}`);
    return response.data;
  }

  async getDocumentViewUrl(
    documentId: string,
    expiresIn = 3600
  ): Promise<{ viewUrl: string; expiresAt: string; expiresIn: number }> {
    const response = await api.get(`/documents/${documentId}/view-url`, {
      params: { expiresIn }
    });
    return response.data;
  }

  async updateDocument(
    documentId: string,
    data: Partial<CreateDocumentRequest>
  ): Promise<Document> {
    const response = await api.patch(`/documents/${documentId}`, data);
    return response.data;
  }
}

export default new DocumentsApi();
